import { generateRoutes } from 'utils/generateRoutes';

export const signInRoutes = generateRoutes({}, 'sign-in');
